var _path, _path2, _path3;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPinterest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.4917 27.4287L16.1871 14.1719",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1871 29.4377C23.5826 29.4377 29.5778 23.4424 29.5778 16.047C29.5778 8.65147 23.5826 2.65625 16.1871 2.65625C8.79161 2.65625 2.79639 8.65147 2.79639 16.047C2.79639 23.4424 8.79161 29.4377 16.1871 29.4377Z",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.93306 20.8039C9.21896 19.3209 8.84814 17.696 8.84814 16.0501V16.0501C8.84814 14.1036 9.62137 12.2369 10.9977 10.8605C12.3741 9.48417 14.2408 8.71094 16.1873 8.71094V8.71094C18.1337 8.71094 20.0005 9.48417 21.3768 10.8605C22.7532 12.2369 23.5264 14.1036 23.5264 16.0501V16.0501C23.5264 16.3007 23.5138 16.5511 23.4885 16.8004C23.2743 18.5168 22.4355 20.0941 21.1323 21.2313C19.829 22.3685 18.1526 22.9859 16.4231 22.9656C15.684 22.9535 14.9629 22.7364 14.3399 22.3386C13.717 21.9408 13.2167 21.3778 12.8948 20.7125L12.8903 20.7035",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinterest);
export default __webpack_public_path__ + "static/media/pinterest.5708695d585e6db884e8fcdb0153499b.svg";
export { ForwardRef as ReactComponent };